// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2XLzi","list":"BalanceDue_list__3rxQQ","listRow":"BalanceDue_listRow__3mQS-","total":"BalanceDue_total__1qbNW"};